import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { CommonService } from '../../../../shared/common.service';
import { InfoMessageItem } from '../../../../model/infomessage';
import { InfoMessageService } from '../../../../shared/infomessage.service';
import { ReturnObject } from '../../../../model/returnobject';
import { InternalMsgService } from '../../../../shared/internal.msg.service';
import { StatusMessagesService } from '../../../../shared/statusmessage.service';

@Component({
    selector: 'sysadmin-set-infomsg',
    templateUrl: './sysadmin-set-infomsg.component.html',
    styleUrls: ['./sysadmin-set-infomsg.component.scss']
})
export class SysadminSetInfomsgComponent implements OnInit {

    todaysDate = new Date().toISOString().split('T')[0];
    tommorowDate = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');

    fromDate: string = this.todaysDate;
    toDate: string = '';
    urgency: string = '1';
    message: string = '';

    infoMessages: InfoMessageItem[] = [];

    constructor(private infoMessageService: InfoMessageService,
        private common: CommonService,
        private statusMessagesService: StatusMessagesService,
        private msgService: InternalMsgService) {
    }

    ngOnInit() {
        this.getActiveMessages();
        
        this.fromDate = this.todaysDate;
        this.toDate = this.tommorowDate;
    }

    getCurrentScheduleDateString(date: Date): string {
        date = new Date(date);
        const dateString = date.toISOString().substring(0, 10);

        return `${dateString}`;
    }

    isDataNotSet(): boolean {
        return ((this.isValuesNotSet(this.message))
            || (this.isValuesNotSet(this.urgency))
            || (this.toDate == undefined)
            || (!this.checkDate())
        );
    }

    isValuesNotSet(value: string): boolean {
        return this.common.isNullOrWhiteSpace(value);
    }

    checkDate(): boolean {
        let checkFromDate = new Date(this.fromDate);
        let checkToDate = new Date(this.toDate);

        return checkToDate.getTime() >= checkFromDate.getTime()
    }

    submitData() {
        const infoMessage = new InfoMessageItem();
        infoMessage.activateDate = new Date(this.fromDate);
        infoMessage.deactivateDate = new Date(this.toDate);
        infoMessage.importance = Number(this.urgency);
        infoMessage.message = this.message;
        infoMessage.header = this.getUrgencyHeader();

        this.addMessage(infoMessage)
    }

    addMessage(msg: InfoMessageItem) {
        this.infoMessageService.setInfoMessage(msg)
            .subscribe((res: ReturnObject<string>) => {
                if (res.isFailure) {
                    this.statusMessagesService.showToasterError('Error', res.failureMessage);
                    return;
                }
                this.getActiveMessages();
                this.statusMessagesService.showToasterInfo('Added', res.value);
            });
    }

    deleteMessage(msg: InfoMessageItem) {
        this.infoMessageService.deleteMessage(msg.id)
            .subscribe((res: ReturnObject<string>) => {
                if (res.isFailure) {
                    this.statusMessagesService.showToasterError('Error', res.failureMessage);
                    return;
                }
                this.getActiveMessages();
                this.statusMessagesService.showToasterInfo('Removed', res.value);
            });
    }

    getActiveMessages() {
      this.msgService.ontoggleSpinnerSet(true);
        this.infoMessageService.getActiveAndScheduledMessages()
            .subscribe((messages: ReturnObject<InfoMessageItem[]>) => {
                if (messages.isFailure) {
                    this.statusMessagesService.showToasterError('Error', messages.failureMessage);
                    return;
                }
                this.msgService.ontoggleSpinnerSet(false);
                this.infoMessages = messages.value;
            });
    }

    getUrgencyHeader(): string {
        switch (this.urgency) {
            case '3':
                return 'INFORMATION';
            case '2':
                return 'ATTENTION';
            default:
                return 'IMPORTANT';
        }
    }

    toISOString(date: Date): string {
        return String(date).split('T')[0];
    }

    isActive(fromDate: Date): boolean {
        const inputDate = new Date(fromDate);
        const thisDate = new Date();
        return (inputDate <= thisDate);
    }

}